function p(i, r, t = void 0) {
  const e = {};
  return Object.keys(i).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (f) => {
      e[f] = i[f].reduce((n, u) => {
        if (u) {
          const o = r(u);
          o !== "" && n.push(o), t && t[u] && n.push(t[u]);
        }
        return n;
      }, []).join(" ");
    }
  ), e;
}
export {
  p as default
};
